import { render } from "./LeaveViewCtrl.vue?vue&type=template&id=4ecc0348&scoped=true"
import script from "./LeaveViewCtrl.vue?vue&type=script&lang=js"
export * from "./LeaveViewCtrl.vue?vue&type=script&lang=js"

import "./LeaveViewCtrl.vue?vue&type=style&index=0&id=4ecc0348&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ecc0348"]])

export default __exports__